import { SharedPacksHeaderController } from './shared-packs-header.controller'

function sharedPacksHeader () {
  return {
    scope: {
      sort: '<?',
      order: '<?',
      onChangeSort: '&',
      viewMode: '@' // "ADMIN" | "GUEST"
    },
    restrict: 'E',
    templateUrl: '/core/directives/shared-packs-header/shared-packs-header.html?$$REVISION$$',
    controller: SharedPacksHeaderController
  }
}

export { sharedPacksHeader }
